<div class="coming-soon-container" fxLayout="row" fxLayoutAlign="center center">
  <img src="assets/image/interface/home/logo.png" alt="Store logo" />
  <h2 class="coming-soon-title">Store Unavailable</h2>
  <p class="coming-soon-message">
    <ng-container *ngIf="storeName; else defaultMsg">
      {{ storeName }} is currently deactivated and not accepting online orders.
    </ng-container>
    <ng-template #defaultMsg>
      This store is currently deactivated and not accepting online orders.
    </ng-template>
  </p>
</div>
